import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-gray-500 text-xs" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }

import { PropType } from 'vue'
import { AccountBalance } from '@/types'
import { usdcTokenDenom } from '@/app/data/token'


export default /*#__PURE__*/_defineComponent({
  __name: 'Label',
  props: {
  isUsdcDenom: Boolean,

  balance: {
    required: true,
    type: Object as PropType<AccountBalance>
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (!__props.isUsdcDenom)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.balance.token.name), 1))
      : (__props.balance.token.denom.toLowerCase() === _unref(usdcTokenDenom).USDC)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('account.usdcPeggyToken')), 1))
        : (__props.balance.token.denom.toLowerCase() === _unref(usdcTokenDenom).USDCet)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('account.usdcWHEthereumToken')), 1))
          : (__props.balance.token.denom.toLowerCase() === _unref(usdcTokenDenom).USDCso)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('account.usdcWHSolanaToken')), 1))
            : _createCommentVNode("", true)
  ]))
}
}

})